import { render } from "./WorkFlowPla.vue?vue&type=template&id=f5481d64"
import script from "./WorkFlowPla.vue?vue&type=script&lang=js"
export * from "./WorkFlowPla.vue?vue&type=script&lang=js"

import "./WorkFlowPla.vue?vue&type=style&index=0&id=f5481d64&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__